import React from 'react'
import MeasurementsTab from './tabs/MeasurementsTab'
import SizesTab from './tabs/SizesTab'
import GridOptionsTab from './tabs/GridOptionsTab'
import ObscurityTab from './tabs/ObscurityTab'
import BlindsTab from './tabs/BlindsTab'
import JobPhotosTab from '../shared/tabs/JobPhotosTab'

const TabContent = ({
  activeTab,
  formData,
  onChange,
  availableOptions,
  windowProduct,
  visibleTabs
}) => {
  const commonProps = {
    formData,
    onChange,
    availableOptions,
    windowProduct
  }

  const renderTabWithVisibility = (tabName, TabComponent) => {
    // Only render if this tab is in the visibleTabs array
    if (!visibleTabs.includes(tabName)) return null

    return (
      <div key={tabName} style={{ display: activeTab === tabName ? 'block' : 'none' }}>
        <TabComponent {...commonProps} />
      </div>
    )
  }

  return (
    <div className="py-6">
      {renderTabWithVisibility('measurements', MeasurementsTab)}
      {renderTabWithVisibility('sizes', SizesTab)}
      {renderTabWithVisibility('grid', GridOptionsTab)}
      {renderTabWithVisibility('obscurity', ObscurityTab)}
      {renderTabWithVisibility('blinds', BlindsTab)}
      {renderTabWithVisibility('job_photos', JobPhotosTab)}
    </div>
  )
}

export default TabContent
